import React, {MutableRefObject, useEffect, useRef, useState} from "react";
import {API_URL, JWT, OFFLINE_DEVELOPMENT} from "./config";

const AVG_DURATION_S = 100;

interface SubmissionProperties {
    evidenceUuid: string,
    unloadListener: MutableRefObject<OnBeforeUnloadEventHandler | undefined>
}

function Submission({evidenceUuid, unloadListener}: SubmissionProperties) {
    const [progress, setProgress] = useState(0);
    const progressUpdater = useRef<null | number>(null)
    const beginTimestamp = useRef((new Date()).getTime())

    useEffect(() => {
        if (progressUpdater.current === null) {
            //begin polling
            if (!OFFLINE_DEVELOPMENT) {
                pollForResult();
            }

            beginTimestamp.current = ((new Date()).getTime())
            progressUpdater.current = window.setInterval(() => {
                let timePassedSecs = (((new Date().getTime())) - beginTimestamp.current)/1e3;
                console.log(timePassedSecs)

                //get estimated progress
                let estimatedProgressPercent = (timePassedSecs / AVG_DURATION_S);

                //at 80%, switch to pessimistic progress calculation, where 100% is impossible to reach
                //(36s is the equivalency point, where these to calculations meet at 80%)
                if (estimatedProgressPercent > 0.8) {
                    let secondsInFuture = AVG_DURATION_S - 0.8 * AVG_DURATION_S

                    estimatedProgressPercent = (timePassedSecs / (timePassedSecs + secondsInFuture))
                }

                setProgress(Math.max(5, Math.round(estimatedProgressPercent * 100)))

            },1000)
        }
    })

    function pollForResult() {
        let timeoutFunction = async () => {
            var myHeaders = new Headers();
            myHeaders.append("Authorization", "Bearer " + JWT);
            myHeaders.append("Content-Type", "application/json");
            let evidenceResponse = await fetch(`${API_URL}evidence/${evidenceUuid}`, {
                method: 'GET',
                headers: myHeaders
            });
            let evidenceResponseJson = await evidenceResponse.json();

            if (evidenceResponseJson.status === "complete") {
                //clear fake progress
                if (progressUpdater.current) {
                    window.clearInterval(progressUpdater.current);
                }


                let linkToPdf = evidenceResponseJson.linkToPDF;
                let downloadLocation = "https://www.netzbeweis.com/report-herunterladen/?id=" + evidenceUuid

                //remove unload event listener
                if (unloadListener.current) {
                    window.removeEventListener("beforeunload", unloadListener.current);
                }

                //dev environment fix
                if (linkToPdf.indexOf("www-dev") !== -1) {
                    document.location = linkToPdf;
                }
                else {
                    document.location = downloadLocation;
                }

                setProgress(100)
            } else {
                window.setTimeout(timeoutFunction, 1000)
            }
        };
        timeoutFunction();
    }

    return (
        <div>
            <div className={"fullPageOverlay d-flex align-items-center justify-content-center"}>
                <div className="container">
                    <div className="col-sm-8 offset-2 p-4 bg-white rounded-4 shadow-lg">
                        <h2 className="mb-4">Dokument wird erstellt...</h2>
                        <div className="progress" role="progressbar">
                            <div className="progress-bar progress-bar-striped progress-bar-animated bg-primary"
                                 style={{width: progress + "%"}}>{progress} %</div>
                        </div>
                        {progress < 100 && (
                            <p className={"mt-4"}>Dieser Vorgang kann einige Minuten dauern.</p>
                        )}
                        {progress === 100 && (
                            <p className={"mt-4"}>Abgeschlossen. Sie werden weitergeleitet. Funktioniert die Weiterleitung nicht,
                                klicken Sie bitte <a href={"https://www.netzbeweis.com/report-herunterladen/?id=" + evidenceUuid}>hier</a>.</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )

}

export default Submission